import { SvgBase } from "../svg.base";

export const ExternalLink: React.FC<{ size?: number }> = ({ size }) => (
  <SvgBase
    width={"" + (size || 16)}
    height={"" + (size || 16)}
    viewBox="0 0 16 16"
  >
    <g id="Subscription-(Web)" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Detail-Subscribed-Live-Popout" transform="translate(-745.000000, -427.000000)" fill="#FFFFFF" fillRule="nonzero">
        <g id="Group-22" transform="translate(308.000000, 86.000000)">
          <g id="Button-/-Small-/-Contain-" transform="translate(355.500000, 333.000000)">
            <g id="Group" transform="translate(16.000000, 5.000000)">
              <g id="Icons-/-Linked" transform="translate(66.000000, 3.000000)">
                <path d="M8.43578947,2 L8.43578947,3.38947368 L3.38315789,3.38947368 L3.38315789,12.6105263 L12.6042105,12.6105263 L12.6042105,7.55789474 L14,7.55789474 L14,12.4210526 C14,13.2930812 13.2930812,14 12.4210526,14 L3.57894737,14 C2.70691882,14 2,13.2930812 2,12.4210526 L2,3.57894737 C2,2.70691882 2.70691882,2 3.57894737,2 L8.43578947,2 Z M14,2 L14,6.47789474 L12.6105263,6.47789474 L12.6105263,4.36210526 L8.00631579,8.95368421 L7.03368421,7.97473684 L11.6126316,3.38947368 L9.50315789,3.38947368 L9.50315789,2 L14,2 Z" id="Combined-Shape"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgBase>
);